import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import logo from 'assets/images/MainLanding/logo.svg';
import { IS_PRODUCTION_ENV } from 'constants/env.constants';

export default function MainLandingHeader() {
  const { pathname } = useLocation();
  const isMainPage = pathname === '/';

  return (
    <header className="header">
      <nav className="header-nav">
        <div className="header-logo">
          <strong className="logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </strong>
        </div>

        <ul className="header-menu-box header-links">
          <li>
            <div className="header-menu-wrapp">
              <span className="header-menu-opener">
                <span className="icon icon-hamburger" />
                <span>myProducts</span>
              </span>
              <ul className="header-menu">
                <li>
                  <Link to="/financial-eor-compliance">
                    Back-Office Solutions
                  </Link>
                </li>
                <li>
                  <Link to="/jobs-talent-aquisition">TA Marketplace</Link>
                </li>
                <li>
                  <Link to="/hr-staffing-solutions">Corporate TA</Link>
                </li>

                {/* Blog is available only on production env */}
                {IS_PRODUCTION_ENV && (
                  <>
                    <li className="hidden-sm-up">
                      <a href={`${window.location.origin}/blog`}>myBlog</a>
                    </li>

                    <li className="hidden-sm-up">
                      <a href={`${window.location.origin}/blog/podcasts`}>
                        myPodcast
                      </a>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </li>

          {/* Blog is available only on production env */}
          {IS_PRODUCTION_ENV && (
            <>
              <li className="hidden-sm-down">
                <a href={`${window.location.origin}/blog`}>myBlog</a>
              </li>

              <li className="hidden-sm-down">
                <a href={`${window.location.origin}/blog/podcasts`}>
                  myPodcast
                </a>
              </li>
            </>
          )}
        </ul>

        <ul className="header-menu-box ml-a">
          {isMainPage && (
            <li>
              <a
                href="https://secure6.saashr.com/ta/6172234.clock"
                target="_blank"
                rel="noreferrer"
                className="header-btn"
              >
                <span>
                  <i className="icon icon-accounting" />
                  <span className="header-btn__text">Worker Login</span>
                </span>
              </a>
            </li>
          )}

          <li>
            <div className="header-menu-wrapp">
              <span className="header-menu-opener">
                <i className="icon icon-login" />
                <span>Member Login</span>
              </span>
              <ul className="header-menu">
                <li>
                  <a href={`${process.env.REACT_APP_BACKOFFICE_URL}/login`}>
                    Back-Office Solutions
                  </a>
                </li>
                <li>
                  <a href={`${process.env.REACT_APP_MARKETPLACE_URL}/login`}>
                    Marketplace Solutions
                  </a>
                </li>
              </ul>
            </div>
          </li>

          <li>
            <div className="header-menu-wrapp">
              <span className="header-menu-opener">
                <i className="icon icon-add-list" />
                <span>Register</span>
              </span>
              <ul className="header-menu">
                <li>
                  <a
                    href={`${process.env.REACT_APP_BACKOFFICE_URL}/registration`}
                  >
                    Back-Office Solutions
                  </a>
                </li>
                <li>
                  <a
                    href={`${process.env.REACT_APP_MARKETPLACE_URL}/registration`}
                  >
                    Marketplace Solutions
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
    </header>
  );
}
